const spanishTable = `<table id="haul_id_shp" style="color: #222831; padding: 3px;">
  <tr style="background-color: #e9ecef;">
    <th colspan="2" style="padding: 12px;">Número de cotización: haul_id_shp</th>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Código de origen: </td>
    <td style="padding: 8px;">origin_zip_code_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Código de destino: </td>
    <td style="padding: 8px;">destination_zip_code_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Número de piezas: </td>
    <td style="padding: 8px;">number_of_pieces_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Dimensiones (Pulgadas): </td>
    <td style="padding: 8px;">all_dimensions_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Peso total (Lbs): </td>
    <td style="padding: 8px;">total_weight_table</td>
  </tr>
  <tr>
    <td style = "padding: 8px; font-weight: bold;">Volumen(Pies cúbicos): </td>
    <td style = "padding: 8px;">cubic_feet_table</td>
  </tr>
  <tr>
    <td style = "padding: 8px; font-weight: bold;">Descripción del producto: </td>
    <td style = "padding: 8px;">all_commodity_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Accesorios: </td>
    <td style="padding: 8px;">all_accessorials_table</td>
  </tr>
  <tr>
    <td style="padding: 8px; font-weight: bold;">Pies lineales: </td>
    <td style="padding: 8px;">linear_feet_table</td>
  </tr>
</table>`;

export default spanishTable;
